import React from 'react'

export const Star = () => {
  return (
    <span style={{ color: "red",fontSize:"13px" }}>*</span>
  )
}
